import React from 'react';

// 2017 질병관리청 한국 소아 평균 데이터 (0-72개월)
const koreanAverageData = {
  boy: {
    0: { height: 49.9, weight: 3.3 },
    1: { height: 54.7, weight: 4.5 },
    2: { height: 58.4, weight: 5.6 },
    3: { height: 61.4, weight: 6.4 },
    4: { height: 63.9, weight: 7.0 },
    5: { height: 65.9, weight: 7.5 },
    6: { height: 67.6, weight: 7.9 },
    7: { height: 69.2, weight: 8.3 },
    8: { height: 70.6, weight: 8.6 },
    9: { height: 72.0, weight: 8.9 },
    10: { height: 73.3, weight: 9.2 },
    11: { height: 74.5, weight: 9.4 },
    12: { height: 75.7, weight: 9.6 },
    13: { height: 76.9, weight: 9.9 },
    14: { height: 78.0, weight: 10.1 },
    15: { height: 79.1, weight: 10.3 },
    16: { height: 80.2, weight: 10.5 },
    17: { height: 81.2, weight: 10.7 },
    18: { height: 82.3, weight: 10.9 },
    19: { height: 83.2, weight: 11.1 },
    20: { height: 84.2, weight: 11.3 },
    21: { height: 85.1, weight: 11.5 },
    22: { height: 86.0, weight: 11.8 },
    23: { height: 86.9, weight: 12.0 },
    24: { height: 87.8, weight: 12.2 },
    30: { height: 90.7, weight: 12.7 },
    36: { height: 95.7, weight: 14.2 },
    42: { height: 101.9, weight: 16.3 },
    48: { height: 105.1, weight: 17.3 },
    54: { height: 108.4, weight: 18.4 },
    60: { height: 114.7, weight: 20.7 },
    66: { height: 117.8, weight: 22.0 },
    72: { height: 120.8, weight: 23.4 }
  },
  girl: {
    0: { height: 49.1, weight: 3.2 },
    1: { height: 53.7, weight: 4.2 },
    2: { height: 57.1, weight: 5.1 },
    3: { height: 59.8, weight: 5.8 },
    4: { height: 62.1, weight: 6.4 },
    5: { height: 64.0, weight: 6.9 },
    6: { height: 65.7, weight: 7.3 },
    7: { height: 67.3, weight: 7.6 },
    8: { height: 68.7, weight: 7.9 },
    9: { height: 70.1, weight: 8.2 },
    10: { height: 71.5, weight: 8.5 },
    11: { height: 72.8, weight: 8.7 },
    12: { height: 74.0, weight: 8.9 },
    13: { height: 75.2, weight: 9.2 },
    14: { height: 76.4, weight: 9.4 },
    15: { height: 77.5, weight: 9.6 },
    16: { height: 78.6, weight: 9.8 },
    17: { height: 79.7, weight: 10.0 },
    18: { height: 80.7, weight: 10.2 },
    19: { height: 81.7, weight: 10.4 },
    20: { height: 82.7, weight: 10.6 },
    21: { height: 83.7, weight: 10.9 },
    22: { height: 84.6, weight: 11.1 },
    23: { height: 85.5, weight: 11.3 },
    24: { height: 87.1, weight: 12.2 },
    30: { height: 91.9, weight: 13.3 },
    36: { height: 96.5, weight: 14.7 },
    42: { height: 103.1, weight: 16.8 },
    48: { height: 106.3, weight: 17.9 },
    54: { height: 112.8, weight: 20.1 },
    60: { height: 119.0, weight: 22.7 },
    66: { height: 122.1, weight: 24.2 },
    72: { height: 127.9, weight: 27.5 }
  }
};

// 중간 개월 수 데이터를 선형 보간으로 계산
const getInterpolatedData = (data, month) => {
  if (data[month]) return data[month];

  const months = Object.keys(data).map(Number).sort((a, b) => a - b);
  let lowerMonth = 0;
  let upperMonth = months[months.length - 1];

  for (let i = 0; i < months.length - 1; i++) {
    if (months[i] <= month && month <= months[i + 1]) {
      lowerMonth = months[i];
      upperMonth = months[i + 1];
      break;
    }
  }

  if (month > upperMonth) return data[upperMonth];

  const ratio = (month - lowerMonth) / (upperMonth - lowerMonth);
  const lowerData = data[lowerMonth];
  const upperData = data[upperMonth];

  return {
    height: parseFloat((lowerData.height + (upperData.height - lowerData.height) * ratio).toFixed(1)),
    weight: parseFloat((lowerData.weight + (upperData.weight - lowerData.weight) * ratio).toFixed(1))
  };
};

function AverageComparison({ profile, latestRecord, babyAge, onClose }) {
  if (!latestRecord) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        padding: '20px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '24px',
          padding: '40px',
          maxWidth: '400px',
          width: '100%',
          textAlign: 'center'
        }}>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#8B7355'
            }}
          >
            ×
          </button>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📝</div>
          <h3 style={{ color: '#E8A87C', marginBottom: '8px' }}>기록이 없습니다</h3>
          <p style={{ color: '#8B7355', fontSize: '14px' }}>먼저 성장 기록을 추가해주세요.</p>
          <button
            onClick={onClose}
            style={{
              marginTop: '20px',
              padding: '12px 24px',
              backgroundColor: '#E8A87C',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer'
            }}
          >
            닫기
          </button>
        </div>
      </div>
    );
  }

  // 72개월(6세) 이상이면 72개월 데이터 사용
  const ageForComparison = Math.min(babyAge, 72);
  const gender = profile.gender;
  const averageData = getInterpolatedData(koreanAverageData[gender], ageForComparison);

  if (!averageData) {
    return null;
  }

  const heightDiff = latestRecord.height - averageData.height;
  const weightDiff = latestRecord.weight - averageData.weight;

  // 2017 질병관리청 한국 소아 백분위수 데이터 (실제 데이터)
  const percentileData = {
    boy: {
      0: {
        height: { p3: 46.3, p10: 47.5, p25: 48.7, p50: 49.9, p75: 51.1, p90: 52.2, p97: 53.5 },
        weight: { p3: 2.5, p10: 2.8, p25: 3.0, p50: 3.3, p75: 3.6, p90: 3.9, p97: 4.3 }
      },
      1: {
        height: { p3: 51.1, p10: 52.5, p25: 53.7, p50: 54.7, p75: 55.9, p90: 57.0, p97: 58.4 },
        weight: { p3: 3.4, p10: 3.8, p25: 4.2, p50: 4.5, p75: 4.9, p90: 5.3, p97: 5.8 }
      },
      2: {
        height: { p3: 54.7, p10: 56.2, p25: 57.4, p50: 58.4, p75: 59.6, p90: 60.7, p97: 62.2 },
        weight: { p3: 4.4, p10: 4.9, p25: 5.3, p50: 5.6, p75: 6.1, p90: 6.5, p97: 7.1 }
      },
      3: {
        height: { p3: 57.6, p10: 59.2, p25: 60.4, p50: 61.4, p75: 62.6, p90: 63.8, p97: 65.4 },
        weight: { p3: 5.1, p10: 5.6, p25: 6.0, p50: 6.4, p75: 6.9, p90: 7.4, p97: 8.1 }
      },
      4: {
        height: { p3: 60.0, p10: 61.7, p25: 62.9, p50: 63.9, p75: 65.1, p90: 66.3, p97: 68.0 },
        weight: { p3: 5.6, p10: 6.2, p25: 6.6, p50: 7.0, p75: 7.5, p90: 8.1, p97: 8.8 }
      },
      5: {
        height: { p3: 62.0, p10: 63.7, p25: 65.0, p50: 65.9, p75: 67.2, p90: 68.4, p97: 70.1 },
        weight: { p3: 6.1, p10: 6.6, p25: 7.1, p50: 7.5, p75: 8.1, p90: 8.6, p97: 9.4 }
      },
      6: {
        height: { p3: 63.6, p10: 65.4, p25: 66.7, p50: 67.6, p75: 68.9, p90: 70.2, p97: 71.9 },
        weight: { p3: 6.4, p10: 7.0, p25: 7.5, p50: 7.9, p75: 8.5, p90: 9.1, p97: 9.9 }
      },
      8: {
        height: { p3: 66.6, p10: 68.5, p25: 69.8, p50: 70.6, p75: 72.0, p90: 73.3, p97: 75.1 },
        weight: { p3: 7.0, p10: 7.6, p25: 8.1, p50: 8.6, p75: 9.3, p90: 9.9, p97: 10.8 }
      },
      9: {
        height: { p3: 67.9, p10: 69.8, p25: 71.1, p50: 72.0, p75: 73.3, p90: 74.7, p97: 76.5 },
        weight: { p3: 7.2, p10: 7.9, p25: 8.4, p50: 8.9, p75: 9.6, p90: 10.2, p97: 11.2 }
      },
      10: {
        height: { p3: 69.1, p10: 71.0, p25: 72.4, p50: 73.3, p75: 74.6, p90: 76.0, p97: 77.9 },
        weight: { p3: 7.5, p10: 8.2, p25: 8.7, p50: 9.2, p75: 9.9, p90: 10.6, p97: 11.5 }
      },
      11: {
        height: { p3: 70.3, p10: 72.3, p25: 73.6, p50: 74.5, p75: 75.9, p90: 77.3, p97: 79.2 },
        weight: { p3: 7.7, p10: 8.4, p25: 8.9, p50: 9.4, p75: 10.2, p90: 10.9, p97: 11.9 }
      },
      12: {
        height: { p3: 71.4, p10: 73.4, p25: 74.8, p50: 75.7, p75: 77.1, p90: 78.5, p97: 80.5 },
        weight: { p3: 7.8, p10: 8.6, p25: 9.1, p50: 9.6, p75: 10.4, p90: 11.2, p97: 12.2 }
      },
      18: {
        height: { p3: 77.6, p10: 79.7, p25: 81.2, p50: 82.3, p75: 83.8, p90: 85.3, p97: 87.5 },
        weight: { p3: 8.9, p10: 9.8, p25: 10.4, p50: 10.9, p75: 11.8, p90: 12.7, p97: 13.9 }
      },
      24: {
        height: { p3: 82.9, p10: 85.2, p25: 86.8, p50: 87.8, p75: 89.4, p90: 91.0, p97: 93.4 },
        weight: { p3: 10.0, p10: 11.0, p25: 11.7, p50: 12.2, p75: 13.2, p90: 14.2, p97: 15.6 }
      },
      36: {
        height: { p3: 90.3, p10: 92.9, p25: 94.7, p50: 95.7, p75: 97.5, p90: 99.3, p97: 102.0 },
        weight: { p3: 11.8, p10: 13.0, p25: 13.8, p50: 14.2, p75: 15.5, p90: 16.7, p97: 18.4 }
      }
    },
    girl: {
      0: {
        height: { p3: 45.6, p10: 46.8, p25: 47.9, p50: 49.1, p75: 50.2, p90: 51.3, p97: 52.5 },
        weight: { p3: 2.4, p10: 2.7, p25: 2.9, p50: 3.2, p75: 3.5, p90: 3.7, p97: 4.1 }
      },
      1: {
        height: { p3: 50.0, p10: 51.4, p25: 52.6, p50: 53.7, p75: 54.8, p90: 55.9, p97: 57.3 },
        weight: { p3: 3.2, p10: 3.6, p25: 3.9, p50: 4.2, p75: 4.6, p90: 4.9, p97: 5.4 }
      },
      2: {
        height: { p3: 53.4, p10: 54.9, p25: 56.1, p50: 57.1, p75: 58.3, p90: 59.4, p97: 60.9 },
        weight: { p3: 4.0, p10: 4.5, p25: 4.8, p50: 5.1, p75: 5.5, p90: 5.9, p97: 6.5 }
      },
      3: {
        height: { p3: 56.1, p10: 57.7, p25: 58.9, p50: 59.8, p75: 61.0, p90: 62.2, p97: 63.7 },
        weight: { p3: 4.6, p10: 5.1, p25: 5.5, p50: 5.8, p75: 6.2, p90: 6.7, p97: 7.3 }
      },
      4: {
        height: { p3: 58.4, p10: 60.0, p25: 61.2, p50: 62.1, p75: 63.4, p90: 64.6, p97: 66.2 },
        weight: { p3: 5.1, p10: 5.6, p25: 6.0, p50: 6.4, p75: 6.9, p90: 7.4, p97: 8.1 }
      },
      5: {
        height: { p3: 60.2, p10: 61.9, p25: 63.2, p50: 64.0, p75: 65.3, p90: 66.6, p97: 68.2 },
        weight: { p3: 5.5, p10: 6.1, p25: 6.5, p50: 6.9, p75: 7.4, p90: 7.9, p97: 8.7 }
      },
      6: {
        height: { p3: 61.8, p10: 63.6, p25: 64.8, p50: 65.7, p75: 67.0, p90: 68.3, p97: 70.0 },
        weight: { p3: 5.9, p10: 6.5, p25: 6.9, p50: 7.3, p75: 7.9, p90: 8.4, p97: 9.2 }
      },
      8: {
        height: { p3: 64.7, p10: 66.5, p25: 67.8, p50: 68.7, p75: 70.1, p90: 71.4, p97: 73.1 },
        weight: { p3: 6.5, p10: 7.1, p25: 7.5, p50: 7.9, p75: 8.5, p90: 9.1, p97: 10.0 }
      },
      9: {
        height: { p3: 65.9, p10: 67.8, p25: 69.1, p50: 70.1, p75: 71.4, p90: 72.8, p97: 74.5 },
        weight: { p3: 6.7, p10: 7.3, p25: 7.8, p50: 8.2, p75: 8.8, p90: 9.5, p97: 10.4 }
      },
      10: {
        height: { p3: 67.2, p10: 69.0, p25: 70.4, p50: 71.5, p75: 72.8, p90: 74.2, p97: 75.9 },
        weight: { p3: 6.9, p10: 7.6, p25: 8.1, p50: 8.5, p75: 9.2, p90: 9.8, p97: 10.8 }
      },
      11: {
        height: { p3: 68.4, p10: 70.3, p25: 71.7, p50: 72.8, p75: 74.1, p90: 75.5, p97: 77.3 },
        weight: { p3: 7.1, p10: 7.8, p25: 8.3, p50: 8.7, p75: 9.5, p90: 10.1, p97: 11.1 }
      },
      12: {
        height: { p3: 69.6, p10: 71.5, p25: 72.9, p50: 74.0, p75: 75.4, p90: 76.8, p97: 78.6 },
        weight: { p3: 7.3, p10: 8.0, p25: 8.5, p50: 8.9, p75: 9.7, p90: 10.4, p97: 11.5 }
      },
      18: {
        height: { p3: 76.0, p10: 78.1, p25: 79.6, p50: 80.7, p75: 82.2, p90: 83.7, p97: 85.9 },
        weight: { p3: 8.4, p10: 9.3, p25: 9.8, p50: 10.2, p75: 11.1, p90: 11.9, p97: 13.1 }
      },
      24: {
        height: { p3: 82.3, p10: 84.6, p25: 86.2, p50: 87.1, p75: 88.7, p90: 90.3, p97: 92.7 },
        weight: { p3: 9.7, p10: 10.7, p25: 11.4, p50: 12.2, p75: 13.2, p90: 14.2, p97: 15.6 }
      },
      36: {
        height: { p3: 90.6, p10: 93.2, p25: 95.0, p50: 96.5, p75: 98.3, p90: 100.1, p97: 102.8 },
        weight: { p3: 11.9, p10: 13.2, p25: 14.0, p50: 14.7, p75: 16.0, p90: 17.3, p97: 19.0 }
      }
    }
  };

  // 백분위수 계산 - 실제 백분위수 데이터 기반
  const calculatePercentile = (value, type) => {
    // 가장 가까운 월령의 백분위수 데이터 찾기
    const availableMonths = [0, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 18, 24, 36];
    let closestMonth = availableMonths.reduce((prev, curr) =>
      Math.abs(curr - ageForComparison) < Math.abs(prev - ageForComparison) ? curr : prev
    );

    const data = percentileData[gender]?.[closestMonth]?.[type];
    if (!data) {
      // 백분위수 데이터가 없으면 평균과 비교하여 추정
      const avg = averageData[type];
      const stdDev = avg * 0.1;
      const zScore = (value - avg) / stdDev;

      if (zScore <= -2) return 3;
      if (zScore <= -1.28) return 10;
      if (zScore <= -0.67) return 25;
      if (zScore <= 0) return 50;
      if (zScore <= 0.67) return 75;
      if (zScore <= 1.28) return 90;
      return 97;
    }

    // 실제 백분위수 데이터와 비교
    if (value <= data.p3) return 3;
    if (value <= data.p10) return Math.round(3 + (value - data.p3) / (data.p10 - data.p3) * 7);
    if (value <= data.p25) return Math.round(10 + (value - data.p10) / (data.p25 - data.p10) * 15);
    if (value <= data.p50) return Math.round(25 + (value - data.p25) / (data.p50 - data.p25) * 25);
    if (value <= data.p75) return Math.round(50 + (value - data.p50) / (data.p75 - data.p50) * 25);
    if (value <= data.p90) return Math.round(75 + (value - data.p75) / (data.p90 - data.p75) * 15);
    if (value <= data.p97) return Math.round(90 + (value - data.p90) / (data.p97 - data.p90) * 7);
    return 97;
  };

  const heightPercentile = calculatePercentile(latestRecord.height, 'height');
  const weightPercentile = calculatePercentile(latestRecord.weight, 'weight');

  const getComparisonText = (diff, unit) => {
    const absDiff = Math.abs(diff);
    if (absDiff < 0.5) {
      return '평균 수준';
    } else if (diff > 0) {
      return `평균보다 ${absDiff.toFixed(1)}${unit} 큼`;
    } else {
      return `평균보다 ${absDiff.toFixed(1)}${unit} 작음`;
    }
  };

  const getComparisonColor = (diff) => {
    const absDiff = Math.abs(diff);
    if (absDiff < 0.5) return '#E8A87C';
    return '#8B7355';
  };

  const getPercentageBar = (actual, average) => {
    const diff = actual - average;
    const percentage = (diff / average) * 100;
    const displayPercentage = Math.min(Math.max(percentage, -20), 20); // -20% ~ +20% 범위로 제한
    const barWidth = Math.abs(displayPercentage) * 2.5; // 비율 조정

    return (
      <div style={{
        width: '100%',
        height: '8px',
        backgroundColor: '#F5E6D3',
        borderRadius: '4px',
        position: 'relative',
        marginTop: '8px'
      }}>
        <div style={{
          position: 'absolute',
          left: '50%',
          width: '2px',
          height: '100%',
          backgroundColor: '#E8A87C'
        }} />
        <div style={{
          position: 'absolute',
          left: displayPercentage >= 0 ? '50%' : `calc(50% - ${barWidth}%)`,
          width: `${barWidth}%`,
          height: '100%',
          backgroundColor: displayPercentage >= 0 ? '#A8D5BA' : '#E8A87C',
          borderRadius: '4px',
          transition: 'width 0.3s ease'
        }} />
      </div>
    );
  };

  return (
    <div className="fade-in" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div className="slide-up" style={{
        backgroundColor: 'white',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '500px',
        width: '100%',
        position: 'relative',
        maxHeight: '80vh',
        overflow: 'auto'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#8B7355'
          }}
        >
          ×
        </button>

        <div style={{
          textAlign: 'center',
          marginBottom: '32px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📈</div>
          <h2 style={{
            color: '#E8A87C',
            fontSize: '24px',
            marginBottom: '8px'
          }}>
            평균 비교
          </h2>
          <p style={{
            color: '#8B7355',
            fontSize: '14px'
          }}>
            {profile.name}와 같은 월령 아기 평균 비교
          </p>
          <p style={{
            color: '#D4956B',
            fontSize: '12px',
            marginTop: '4px'
          }}>
            질병관리청·대한소아과학회 최신 자료 기준
          </p>
        </div>

        <div style={{
          backgroundColor: '#FAF3E8',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '16px'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <span style={{ color: '#8B7355', fontSize: '14px' }}>현재 월령</span>
            <span style={{ color: '#E8A87C', fontWeight: 'bold', fontSize: '16px' }}>
              {ageForComparison}개월
            </span>
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <span style={{ color: '#8B7355', fontSize: '14px' }}>성별</span>
            <span style={{ color: '#E8A87C', fontWeight: 'bold', fontSize: '16px' }}>
              {gender === 'boy' ? '👦 남아' : '👧 여아'}
            </span>
          </div>
        </div>

        {/* 키 비교 */}
        <div style={{
          backgroundColor: 'white',
          border: '2px solid #F5E6D3',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '16px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '12px'
          }}>
            <span style={{ fontSize: '24px', marginRight: '8px' }}>📏</span>
            <h3 style={{ color: '#E8A87C', margin: 0 }}>키</h3>
          </div>

          <div style={{ marginBottom: '12px' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '4px'
            }}>
              <span style={{ color: '#8B7355', fontSize: '14px' }}>우리 아기</span>
              <span style={{ color: '#E8A87C', fontWeight: 'bold' }}>
                {latestRecord.height}cm
              </span>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}>
              <span style={{ color: '#8B7355', fontSize: '14px' }}>평균</span>
              <span style={{ color: '#D4956B' }}>{averageData.height}cm</span>
            </div>
          </div>

          {getPercentageBar(latestRecord.height, averageData.height)}

          <div style={{
            marginTop: '12px',
            padding: '16px',
            backgroundColor: '#FAF3E8',
            borderRadius: '12px'
          }}>
            <div style={{
              color: getComparisonColor(heightDiff),
              fontWeight: 'bold',
              fontSize: '14px',
              marginBottom: '8px',
              textAlign: 'center'
            }}>
              {getComparisonText(heightDiff, 'cm')}
            </div>
            <div style={{
              fontSize: '16px',
              color: '#E8A87C',
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: '8px'
            }}>
              백분위수: {heightPercentile}
            </div>
            <div style={{
              fontSize: '12px',
              color: '#8B7355',
              textAlign: 'center'
            }}>
              {heightPercentile >= 75 ? '🌟 상위 그룹' :
               heightPercentile >= 50 ? '👍 평균 이상' :
               heightPercentile >= 25 ? '✅ 평균 수준' :
               '💙 건강하게 성장 중'}
            </div>
            <div style={{
              fontSize: '11px',
              color: '#D4956B',
              textAlign: 'center',
              marginTop: '4px'
            }}>
              100명 중 {(100 - heightPercentile)}명보다 큼
            </div>
          </div>
        </div>

        {/* 몸무게 비교 */}
        <div style={{
          backgroundColor: 'white',
          border: '2px solid #F5E6D3',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '20px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '12px'
          }}>
            <span style={{ fontSize: '24px', marginRight: '8px' }}>⚖️</span>
            <h3 style={{ color: '#D4956B', margin: 0 }}>몸무게</h3>
          </div>

          <div style={{ marginBottom: '12px' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '4px'
            }}>
              <span style={{ color: '#8B7355', fontSize: '14px' }}>우리 아기</span>
              <span style={{ color: '#D4956B', fontWeight: 'bold' }}>
                {latestRecord.weight}kg
              </span>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}>
              <span style={{ color: '#8B7355', fontSize: '14px' }}>평균</span>
              <span style={{ color: '#D4956B' }}>{averageData.weight}kg</span>
            </div>
          </div>

          {getPercentageBar(latestRecord.weight, averageData.weight)}

          <div style={{
            marginTop: '12px',
            padding: '16px',
            backgroundColor: '#FAF3E8',
            borderRadius: '12px'
          }}>
            <div style={{
              color: getComparisonColor(weightDiff),
              fontWeight: 'bold',
              fontSize: '14px',
              marginBottom: '8px',
              textAlign: 'center'
            }}>
              {getComparisonText(weightDiff, 'kg')}
            </div>
            <div style={{
              fontSize: '16px',
              color: '#D4956B',
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: '8px'
            }}>
              백분위수: {weightPercentile}
            </div>
            <div style={{
              fontSize: '12px',
              color: '#8B7355',
              textAlign: 'center'
            }}>
              {weightPercentile >= 75 ? '🌟 상위 그룹' :
               weightPercentile >= 50 ? '👍 평균 이상' :
               weightPercentile >= 25 ? '✅ 평균 수준' :
               '💙 건강하게 성장 중'}
            </div>
            <div style={{
              fontSize: '11px',
              color: '#D4956B',
              textAlign: 'center',
              marginTop: '4px'
            }}>
              100명 중 {(100 - weightPercentile)}명보다 무거움
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: '#F5E6D3',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '20px'
        }}>
          <div style={{
            color: '#E8A87C',
            fontSize: '13px',
            fontWeight: 'bold',
            marginBottom: '8px'
          }}>
            📊 백분위수란?
          </div>
          <p style={{
            color: '#8B7355',
            fontSize: '12px',
            margin: 0,
            lineHeight: '1.6'
          }}>
            백분위수는 같은 월령 아기 100명 중 우리 아기의 위치를 나타냅니다.<br />
            • 50 백분위: 평균 (중간)<br />
            • 75 백분위: 100명 중 25등<br />
            • 25 백분위: 100명 중 75등<br /><br />
            💡 모든 아기는 고유한 성장 속도를 가지고 있습니다. 3~97 백분위 사이면 정상 범위이며, 궁금한 점은 소아과 전문의와 상담하세요.
          </p>
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '16px',
            backgroundColor: '#E8A87C',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#D4956B'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#E8A87C'}
        >
          닫기
        </button>
      </div>
    </div>
  );
}

export default AverageComparison;
